import axios from 'axios';

function baseUrlFromAzureChatEnv() {
  const chat = process.env.REACT_APP_AZURE_AI_BACKEND_URL;
  if (!chat) return undefined;
  return chat
    .replace(/\/api\/v1\/chat\/?$/, '')
    .replace(/\/api\/chat\/?$/, '');
}

const AI_BACKEND_URL =
  process.env.REACT_APP_AI_BACKEND_URL ||
  baseUrlFromAzureChatEnv() ||
  'http://localhost:5000';

/** Authenticated AI backend client for the platform admin routes (also used by KnowledgeLibraryApi). */
export const getAuthClient = () => {
  const token = localStorage.getItem('jwtToken');
  return axios.create({
    baseURL: AI_BACKEND_URL,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    timeout: 30000,
  });
};

export const getLegalPacks = () => {
  const client = getAuthClient();
  return client.get('/api/v1/admin/legal-packs');
};

/** GET /api/v1/admin/job-queues: health of the ingestion and policy review queues (platform admins). */
export const getJobQueues = () => getAuthClient().get('/api/v1/admin/job-queues');

/** GET /api/v1/admin/policy-review-jobs: reviews with the phase of their latest job, every organisation. */
export const getPolicyReviewJobs = (params = {}) => getAuthClient().get('/api/v1/admin/policy-review-jobs', { params });

export const getAiModels = () => {
  const client = getAuthClient();
  return client.get('/api/v1/admin/ai-models');
};

/**
 * Either one slot, `{ slot_id, deployment?, reasoning_effort? }` (an omitted key stays as it is,
 * null clears it), or the platform switch `{ zavvy_reasoning_visibility: 'everyone' | 'admins' }`.
 * @param {{ slot_id?: string, deployment?: string|null, reasoning_effort?: string|null, zavvy_reasoning_visibility?: string }} body
 */
export const updateAiModel = (body) => {
  const client = getAuthClient();
  return client.post('/api/v1/admin/ai-models', body);
};
